// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_cq-0";
export var fileCarousel = "_cq-2";
export var removeFileButton = "_cq-1";